/**
 * A button.
 *
 * Sized for a finger on a busy counter, not a mouse: the smallest variant is
 * still 44px tall, which is the smallest target most people can hit reliably
 * without looking. Anything smaller costs a mis-tap on every shift.
 */
/**
 * Dark text on the brand green, not white.
 *
 * #7ED957 is a bright colour — white on it fails contrast badly, and on a till
 * under strip lighting it reads as a green smudge. Near-black on it is legible
 * across the counter, which is the distance this is read from.
 */
const VARIANTS = {
  primary:
    'bg-brand-400 text-surface-2 hover:bg-brand-300 active:bg-brand-500 shadow-[0_0_16px_rgba(126,217,87,0.25)]',
  secondary: 'bg-surface-3 text-ink border border-rule hover:border-rule-strong hover:bg-rule',
  ghost: 'text-ink-2 hover:bg-surface-3 active:bg-surface-3',
  danger: 'bg-bad text-surface-2 hover:brightness-110 active:brightness-95',
};

const SIZES = {
  sm: 'h-11 px-4 text-sm',
  md: 'h-12 px-5 text-[15px]',
  lg: 'h-14 px-6 text-base',
};

export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  busy = false,
  disabled,
  children,
  ...props
}) {
  return (
    <button
      // A button doing something must not be pressable again — that is how one
      // order becomes two.
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      className={`
        inline-flex items-center justify-center gap-2 rounded-lg font-medium
        transition-colors disabled:pointer-events-none disabled:opacity-50
        ${VARIANTS[variant]} ${SIZES[size]} ${className}
      `}
      {...props}
    >
      {busy && (
        <span
          aria-hidden="true"
          className="size-4 animate-spin rounded-full border-2 border-current border-t-transparent"
        />
      )}
      {children}
    </button>
  );
}
